import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import InvestorView from "./InvestorView";
import Button from '@material-ui/core/Button';

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
          backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    activeRow:{
        //backgroundColor: theme.navigation.selected.backgroundColor + ' !important',
        //color:theme.navigation.selected.contrast,
    },
});

class ViewInvestorButton extends Component {
    expand = () => {
        const app = this;

        app.props.context.update({
            drawerContent:(<InvestorView investor={app.props.row}/>),
            drawerWidth:'80vw'
        })

    };

    render() {

        return (
            <Button size="small" variant="outlined" color="primary" onClick={this.expand}>
              View
            </Button>
        );
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(ViewInvestorButton)));
